module.exports = __webpack_public_path__ + "img/message-time.ae8425cb.svg";